

const calculatedColumnNames = {
	select: 'data-table-select',
	expand: 'data-table-expand',
	actions: 'actions',
} as const

type CalculatedColumnNames = keyof typeof calculatedColumnNames

export { calculatedColumnNames as default, type CalculatedColumnNames }